import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import './plugins/cookies-vue'
import './plugins/flash-vue'
import './plugins/vee-validate.js'
import './plugins/public-path.js'
import './plugins/mixins.js'
import './plugins/languages-list.js'
import './plugins/countries-list.js'
import './plugins/lazy-load.js'
import './plugins/currency-symbol.js'
import './plugins/date-format.js'
import './plugins/google-tag-manager.js'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import StdButton from './components/buttons/StdButton'
import PageTitle from './components/PageTitle'
import TitleBlock from './components/TitleBlock'
import PageLoader from './components/PageLoader'
import Multiselect from 'vue-multiselect'
import wb from './registerServiceWorker'

Vue.prototype.$workbox = wb

Vue.component('std-button', StdButton)
Vue.component('page-title', PageTitle)
Vue.component('title-block', TitleBlock)
Vue.component('page-loader', PageLoader)
Vue.component('multiselect', Multiselect)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
